import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import {FormattedMessage} from "react-intl";

import Navigation from "./navigation";
import Config from "../../../config";
import {ignoreDefault} from "../../../misc/utils";
import Sidebar from './desktop/sidebar';
import Body from './desktop/body';
import {ContentType, ContentTypeName, ContentTypeNameTranslate, PartMenuType} from "../constants";
import FeatureWizard from "./featureWizard/featureWizard";
import Analytics from "../../../analytics";
import {CABINET_WIZARD_BUTTONS, BACKSPLASH_TYPES, COUNTERTOP_WIZARD_BUTTONS} from "../../kvComponent/core/constants";
import {getCurrentLayout} from "../../appLayout";
import RoomSceneNavigation from "./roomSceneNavigation";
import {getAvailableRoomScenes, getShowOtherLayouts, getSideBarSubParts} from "./navUtils";
import DesktopNavigationLayoutsContent from "./desktopNavigationLayoutsContent";

export default class DesktopNavigationCommon extends Navigation {

  static propTypes = {
    refreshCB: PropTypes.func.isRequired,
    renderGreenLayerByZindex: PropTypes.func,
    changeMessageBoxState: PropTypes.func,
    setHoveredLayer: PropTypes.func,
    userIsLoggedIn: PropTypes.bool,
    isPhoneNumberValidated: PropTypes.bool,
    toggleUserPopup: PropTypes.func,
    setActiveFeature: PropTypes.func,
    setDemoPointClicked: PropTypes.func,
    activeFeature: PropTypes.object,
    fabricatorSettings: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.navWrapper = null;
    this.navigationIsClosing = false;
  }

  componentDidMount() {
    this.setState({
      navWidth: $(this.navWrapper).width()
    });
    this.props.setNavigationViewType(3);
    this._componentDidMount();
  }

  componentWillReceiveProps(nextProps) {
    this._componentWillReceiveProps(nextProps)
  }

  handleContextMenuClick = (menuItem) => {
    const layout = getCurrentLayout();
    if (!this.state.showNavigation) {
      let clickedParent = "", clickedButton = "";
      const isBacksplash = BACKSPLASH_TYPES.some(bType => bType === menuItem.text);
      if (menuItem.text === "Edge Profile") {
        if (this.props.setActiveNavigationFilter) {
          this.props.setActiveNavigationFilter(COUNTERTOP_WIZARD_BUTTONS[3].buttonId);  // set active navigation filter
          this.props.setActiveNavigationFilterStepIndex(3);
        }
      } else if (isBacksplash) {
        const wallsParent = layout.parts["Walls"];
        const backsplashSubPart = wallsParent.relatedItems.find(relItem => relItem.partId === "backsplash");
        clickedParent = "Walls";
        clickedButton = "Backsplash";
        if (this.props.setActiveNavigationFilter) {
          this.props.setActiveNavigationFilter(COUNTERTOP_WIZARD_BUTTONS[4].buttonId);  // set active navigation filter
          this.props.setActiveNavigationFilterStepIndex(4);
        }
        const applyBacksplash = () => {
          const featureToClick = backsplashSubPart.getFeatureByBacksplashType(menuItem.text);
          if (featureToClick) {
            console.log("featureToClick", featureToClick);
            featureToClick.handleClick();
            this.props.setActiveFeature(featureToClick);
            const parentItem = this.state.parentNavigationItem;
            this.setState({
              parentNavigationItem: null
            }, () => {
              this.setState({
                parentNavigationItem: parentItem
              })
            })
          }
        }
        if (!backsplashSubPart.allFeaturesReceived) {
          this.checkIfAllFeaturesReceived({part: backsplashSubPart}, null, applyBacksplash);
        } else {
          applyBacksplash()
        }
      }
      if (!isBacksplash) {
        clickedButton = menuItem.text;
        clickedParent = menuItem.subMenuParent || this.state.contextMenuOpen;
      }
      if (clickedParent && clickedParent.module) {
        clickedParent = "Cabinet"
      }
      //
      // console.log('clickedButton', clickedButton);
      // console.log('clickedParent', clickedParent);
      // console.log('menuItem', menuItem);
      if (clickedParent === "Walls" && (clickedButton === "Left Shower Wall" || clickedButton === "Pony Wall")) {
        this.ponyWallAndLeftWallClick(menuItem);
      }

      this.setState({
        showNavigation: true,
        contentType: ContentType.Design,
        contextMenuOpen: false,
        hoveredLayer: {}
      }, () => {
        this.menuOpened();
        this.triggerOpenNavigationMenu(clickedButton, clickedParent);
        $(document).on('click', this.handleWrapperBlur);
        this.setNewActiveFeature();
        if (menuItem.clickFeature && !isBacksplash) {
          const featureToClick = menuItem.part.features.find(feature => feature.partName === menuItem.subMenuText);
          if (featureToClick) {
            featureToClick.handleClick();
          }
        }
      });
    }
  };

  handleNavTabClick = (contentType) => (e) => {
    Analytics.sendClickEvent('nav-tab-click-' + contentType);
    // console.log('e', e);
    // console.log('contentType', contentType);
    ignoreDefault(e);
    if (this.state.contentType === contentType) {
      this.closeNavigation(e);
    } else if (!this.navigationIsClosing) {
      this.setContentType(contentType);
    }
  };

  openLayoutMenu = (callBack) => {
    const contentType = document.querySelector(".tab.tab--room-layout")
      ? ContentType.Layout
      : document.querySelector(".tab.tab--room-ideas")
        ? ContentType.DisplayRoom
        : ContentType.Layout;
    this.setState({
      showNavigation: true,
      contentType,
      contextMenuOpen: false,
      hoveredLayer: {}
    }, () => {
      this.setNewActiveFeature();
      this.menuOpened();
      $(document).on('click', this.handleWrapperBlur);
      callBack();
    });
  };

  menuOpened = () => {
    this._menuOpened();
  };

  setContentType = (contentType) => {
    this.setState({
      showNavigation: true,
      contentType,
      contextMenuOpen: false,
      hoveredLayer: {},
      activeDefaultPreset: null
    }, () => {
      this.menuOpened();
      $(document).on('click', this.handleWrapperBlur);
      if (contentType === ContentType.Design) {
        this.setNewActiveFeature();
      }
    });
  };

  closeNavigation = (e) => {
    Analytics.sendClickEvent('close-nav');
    if (e) {
      ignoreDefault(e);
    }
    this.props.setActiveFeature(null);
    this.navigationIsClosing = true;
    this.setState({
      showNavigation: false,
      showFilterSelection: false,
      showerWallWizardGroupsSelected: true,
    }, () => {
      setTimeout(() => {
        this.setState({
          contentType: ContentType.None,
          showFilterSelection: true,
          showerWallWizardGroupsSelected: false,
          searchText: ""
        }, () => {
          this.navigationIsClosing = false;
        })
      }, 500);
      $(document).off('click', this.handleWrapperBlur);
    });
    if (this.props.setActiveNavigationNames) {
      this.props.setActiveNavigationNames("", "")
    }
    setTimeout(() => {
      if (this.props.toggleDesktopNavigation) {
        this.props.toggleDesktopNavigation(false)
      }
      if (this.props.setActiveNavigationFilter) {
        this.props.setActiveNavigationFilter(CABINET_WIZARD_BUTTONS[0].buttonId);
        this.props.setActiveNavigationFilterStepIndex(0);
      }
    }, 500);
  };

  handleWrapperBlur = (e) => {
    const overlayClick = e.target.closest('.nav-overlay');
    const navClick = e.target.closest('.nav');
    const lockClick = e.target.closest('[class*="lock"]');
    const userPopupClick = e.target.closest('[class*="user-popup"]');
    if (overlayClick && !navClick && !lockClick && !userPopupClick && !e.target.closest('.nav-pos')) {
      this.closeNavigation(e);
    }
  };

  handleHeaderBackClick = () => {
    this.resetNavigation();
  };

  updateSideBar = () => {
    this.setState({
      updateSidebarItems: true
    }, () => {
      this.setState({
        updateSidebarItems: false
      })
    })
  };

  handleSubPartClick = (childNavigationItem, activeNavigationFilter = null) => { // sidebar list item click
    const subItemPart = childNavigationItem.part;
    const childNavigationItemPartId = subItemPart.partId;
    if (Config.isDevMode() && this.state.childNavigationItem && (this.state.childNavigationItem.text === childNavigationItem.text || subItemPart.disabled)) {
      if (subItemPart.canBeDisabled && subItemPart.disabled) {
        subItemPart.disabled = !subItemPart.disabled;
        subItemPart.disabledClick();
        this.props.refreshCB();
      }
    }
    subItemPart.getParent().handleSubPartClick(subItemPart);
    this.setState({
      childNavigationItem,
      showFilterSelection: subItemPart.allFeaturesReceived, // show filters only if subItemPart has all features
      showerWallWizardGroupsSelected: false,
      searchText: ""
    }, () => {
      this.scrollAsideToMenuItem(childNavigationItem.text);
      this.rememberWallsSelection();
      this.checkIfAllFeaturesReceived(childNavigationItem, "childNavigationItem");
    });
    this.setNewActiveFeature(childNavigationItem);
    /*set new materials page subIndex*/
    this.setActivePartRelatedItemIndex(childNavigationItem);

    if (this.props.setActiveNavigationNames
      && this.state.parentNavigationItem && this.state.parentNavigationItem.text
      && childNavigationItem && childNavigationItem.part
    ) {
      this.props.setActiveNavigationNames(
        this.state.parentNavigationItem.text.toLowerCase().replace(/ /g,"_"),
        childNavigationItemPartId
      )
    }

    this.setNavigationFilterIfTheChildWasChanged(childNavigationItemPartId, activeNavigationFilter);

    if (childNavigationItem.text === "Ceiling") {
      $('html, body').animate({scrollTop: 0}, 800);
    }

  };

  scrollAsideToMenuItem = (menuItemText) => {
    const parent = $(document.querySelector('.customize-list'));
    const child = parent.find('.customize-list__item[data-text="'+ menuItemText +'"]');
    if (parent && child) {
      const needToScroll = +child.data('index') >= 5;
      parent.animate({
        scrollTop: needToScroll ? parent.height() : 0 // -30 this is one nav item height
      }, 500);
    }
  };

  handleSubPartHover = childNavigationItem => {
    const activeFeature = childNavigationItem.part.activeFeature;
    if (activeFeature) {
      const zIndex = activeFeature.layer.zIndex;
      zIndex && this.props.renderGreenLayerByZindex(zIndex);
    }
  };

  scrollToDefault = () => {
    const featuresList = document.getElementsByClassName('categories-list');
    if (featuresList.length) {
      featuresList[0].scrollLeft = 0;
    }
  };

  handleMobileSelectClick = (e) => {
    if (!this.state.showNavigation || !this.state.parentNavigationItem) {
      e.stopPropagation();
      if (!this.state.parentNavigationItem) {
        this.setState({
          childNavigationItem: null
        })
      }
    }
    if (this.state.contentType !== ContentType.Design && !this.navigationIsClosing) {
      this.setContentType(ContentType.Design);
    }
  };

  navigationItemClickCommon = (item) => {
    if (!this.state.parentNavigationItem) {
      if (item.part.menuType === PartMenuType.Simple) {
        this.checkIfAllFeaturesReceived(item, "parentNavigationItem");
      }
      this.setState({
        parentNavigationItem: item,
        showFilterSelection: item.text === "Floor" && item.part.allFeaturesReceived, // show filters only if subItemPart has all features
      }, () => {
        const featuresList = document.getElementsByClassName('categories-list');
        if (featuresList.length) {
          featuresList[0].scrollLeft = 0;
        }
        // let activeFeature = item.part.activeFeature;
        const subParts = getSideBarSubParts(this.state.parentNavigationItem.part);
        if (subParts[0] && (subParts[0].part.menuType !== PartMenuType.Simple)) {
          this.handleSubPartClick(subParts[0])
        } else {
          setTimeout(() => {
            this.setNewActiveFeature({part: item.part});
          }, 0)
        }
        if (this.props.setActiveNavigationNames && this.state.parentNavigationItem && this.state.parentNavigationItem.text) {
          this.props.setActiveNavigationNames(
            this.state.parentNavigationItem.text.toLowerCase().replace(/ /g,"_"), ""
          )
        }
      });
      this.props.setDefaultSelectionGroup(item.part.partName);
    } else {
      this.props.setActiveFeature(item.part);
    }
    if (Config.isDevMode() || document.kvConfig.kioskMode) {
      console.log('item', item);
      if (item.part.dbFeature) {
        console.log('sharedFeatureName:', item.part.dbFeature.sharedFeatureName);
      }
    }
  };

  content = (useWizard, wizardGroups, useFilters) => {
    let content = null;
    switch (this.state.contentType) {
      case ContentType.Design:
        return this.contentDesign(useWizard, wizardGroups, useFilters);
      case ContentType.Layout:
        return <DesktopNavigationLayoutsContent handleLayoutItemClick={this.handleLayoutItemClick}/>;
      case ContentType.DisplayRoom:
        return this.contentRoom();
      case ContentType.Loading:
        return this.contentLoading();
      case ContentType.RoomScene:
        return <RoomSceneNavigation/>;
      default:
        return content;
    }
  };

  contentDesignBody = (useWizard, wizardGroups, useFilters = false) => {
    return (
      <Body parentItem={this.state.parentNavigationItem}
            childItem={this.state.childNavigationItem}
            onItemClick={this.handleNavigationItemClick}
        //filters={filters}
            searchText={this.state.searchText}
            navWidth={this.state.navWidth}
            toggleApplyWallsCheckbox={this.toggleApplyWallsCheckbox}
            isWallItem={this.isWallItem}
            handleSubTypeClick={this.handleSubTypeClick}
            toggleUserPopup={this.props.toggleUserPopup}
            showMenu={this.state.showNavigation && (this.state.contentType === ContentType.Design)}
            activeFeature={this.props.activeFeature}
            setStateActiveFeature={this.props.setActiveFeature}
            useWizard={useWizard}
            showFeatureWizard={this.state.showFeatureWizard}
            wizardGroups={wizardGroups}
            enableFeatureWizard={this.enableFeatureWizard}
            exitFeatureWizard={this.exitFeatureWizard}
            getFilterDisplayName={this.getFilterDisplayName}
            useFilters={useFilters}
            removeFilterSelection={this.removeFilterSelection}
            showFilterSelection={this.state.showFilterSelection}
            toggleWizardFilterSelection={this.toggleWizardFilterSelection}
            refreshCB={this.props.refreshCB}
      />
    )
  };

  contentDesignWizard = () => {
    const wizardGroups = this.state[this.getWizardGroupsByPartId(this.state.childNavigationItem.part.partId)];
    return (
      <FeatureWizard
        features={this.state.childNavigationItem.part.features}
        exitFeatureWizard={this.exitFeatureWizard}
        wizardGroups={wizardGroups}
        handleNavigationItemClick={this.handleNavigationItemClick}
        isMobile={false}
        setWizardGroups={this.setWizardGroups}
        changeMessageBoxState={this.props.changeMessageBoxState}
        isPhoneNumberValidated={this.props.isPhoneNumberValidated}
        userIsLoggedIn={this.props.userIsLoggedIn}
        toggleUserPopup={this.props.toggleUserPopup}
        activePart={this.state.parentNavigationItem.part}
        activeSubPart={this.state.childNavigationItem.part}
        toggleApplyWallsCheckbox={this.toggleApplyWallsCheckbox}
        isWallItem={this.isWallItem}
        handleSubTypeClick={this.handleSubTypeClick}
        setWizardLockedItem={this.setWizardLockedItem}
        wizardStepIndex={this.state.wizardStepIndex}
        getFilterDisplayName={this.getFilterDisplayName}
        showerWallWizardGroupsSelected={this.state.showerWallWizardGroupsSelected}
        toggleWizardFilterSelection={this.toggleWizardFilterSelection}
        handleSearchInputChange={this.handleSearchInputChange}
        searchText={this.state.searchText}
      />
    )
  };

  contentDesign = (useWizard, wizardGroups, useFilters) => {

    // activePart = activePart || {
    //   text: ''
    // };
    /*const filters = this.state.filters[activePart.text] || {};
    const filterValuesIDs = [];
    each(filters, (value) => {
      filterValuesIDs.push(value);
    });*/

    return (
      <div className="design">
        {this.state.parentNavigationItem
          ? <Sidebar part={this.state.parentNavigationItem.part}
                     onBackClick={this.handleHeaderBackClick}
                     onSubTypeClick={this.handleSubTypeClick}
                     onSubPartClick={this.handleSubPartClick}
                     onSubPartHover={this.handleSubPartHover}
                     handleSearchInputChange={this.handleSearchInputChange}
                     searchText={this.state.searchText}
                     updateSidebarItems={this.state.updateSidebarItems}
                     activeChildNavigationItem={this.state.childNavigationItem}/>
          : null}
        {this.state.showFeatureWizard ? (
          useWizard && this.state.childNavigationItem && this.state.childNavigationItem.part && this.state.parentNavigationItem
            ? this.contentDesignWizard()
            : this.contentDesignBody(false, wizardGroups, useFilters)
        ) : this.contentDesignBody(useWizard, wizardGroups, useFilters)}
        {/*{this.state.parentNavigationItem*/}
        {/*? <FeatureFiltersView layout={layout}*/}
        {/*parentItem={this.state.parentNavigationItem}*/}
        {/*childItem={this.state.childNavigationItem}*/}
        {/*allFilterGroups={this.props.allFilterGroups}*/}
        {/*filters={filters}*/}
        {/*applyFilterClick={this.handleApplyFilter}*/}
        {/*selectedFilterValues={filterValuesIDs} click={this.handleFilterClick}/>*/}
        {/*: null}*/}
      </div>
    )
  };

  contentRoom = () => {
    let presets = this.checkedForLockedPresets();
    return (
      <div className={"layout" + (!this.props.bvPresets.length ? " layout--empty" : "")}>
        {presets.length ? (
          <ul className="layout-list">
            {presets.map((preset, index) => {
              return (
                <li className={"layout-list__item layout-list__item--preset"
                + (this.state.activeDefaultPreset === index ? " active" : "")
                + (preset.presetIsLocked ? " layout-list__item--locked" : "")}
                    key={"preset" + index} onClick={() => this.handleDefaultPresetClick(index, preset.presetIsLocked)}
                    style={{backgroundImage: `url(${preset.bv_screen})`}}/>
              )
            })}
          </ul>
        ) : <p className="layout-text"><FormattedMessage id="desktop.noPresetsMessage"/></p>}
      </div>
    )
  };

  contentLoading = () => {
    return <div className="message-loading-left-panel-spinner message-loading-left-panel-spinner--small"/>
  }

  navigationMenuButtons = (availableNavButtons) => {
    return (
      <div className="nav-wrapper__tabs">
        {availableNavButtons.map((contentType) => {
          if (ContentTypeName[contentType] === "Room Layout") {
            const showOtherLayouts = getShowOtherLayouts(this.props.fabricatorSettings);
            if (!showOtherLayouts) {
              return null
            }
          }
          if (ContentTypeName[contentType] === "Room Scene") {
            const showOtherLayouts = getAvailableRoomScenes();
            if (!showOtherLayouts || !showOtherLayouts.length || (showOtherLayouts.length === 1)) {
              return null
            }
          }
          if (ContentTypeName[contentType] === "Room Scene" && (document.kvConfig.visualizerType === "kvScene" && !Config.isDevMode())) {
            return null
          }
          const tabClassName = ContentTypeName[contentType].toLowerCase().replace(" ","-")
          return (
            <div className={"tab tab--" + tabClassName + (this.state.contentType === contentType ? " tab--active" : "")}
                 key={"navTab" + contentType}
                 onClick={this.handleNavTabClick(contentType)}>
               <span className="tab-text">
                <FormattedMessage id={ContentTypeNameTranslate[contentType]}/>
              </span>
            </div>
          )
        })}
      </div>
    )
  }

}
